export { default } from './withSharedSnackbar.jsx'



// WEBPACK FOOTER //
// ./src/components/HOCs/withSharedSnackbar/index.js